// React
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
// Redux
import { Provider } from "react-redux";
// Router
import { ConnectedRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
// Store
import configureStore from "./infrastructure/store/ConfigureStore";
// Localization
import "./i18n";
// IoC Container
import "reflect-metadata"; // Import only once
// Logging
import * as log from "loglevel";
//import remote from "loglevel-plugin-remote";
// OIDC
import { OidcProvider } from "redux-oidc";
import UserManager from "./infrastructure/oidc/UserManager";
// Others
import * as serviceWorker from "./serviceWorker";
import "./index.scss";
import "styles/themes/alpiq/overrides.scss";

import App from "./App";

// Config
// Log
log.setDefaultLevel(log.levels.DEBUG);


// Create browser history to use in the Redux store
const history = createBrowserHistory();

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history, (window as any).initialReduxState);

ReactDOM.render(
    <Provider store={store}>
        <OidcProvider store={store} userManager={UserManager}>
            <ConnectedRouter history={history}>
                <React.StrictMode>
                    <Suspense fallback="Loading...">
                        <App />
                    </Suspense>
                </React.StrictMode>
            </ConnectedRouter>
        </OidcProvider>
    </Provider>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
